import { useFilterContext } from '../../context/filter-context'
import { Eye, EyeOff } from 'lucide-react'
import React from 'react'

/**
 * Completed Workouts visibility toggle (GH-754 §3.2). Default is Show (eye open). Toggling on
 * sets `hideCompleted`, which the Results query forwards to the GH-774 API. No Rated Workouts
 * toggle — intentionally omitted per spec.
 */
export const CompletedWorkoutsToggle = (): React.ReactElement => {
  const { hideCompleted, setHideCompleted } = useFilterContext()
  return (
    <button
      type="button"
      onClick={() => setHideCompleted(!hideCompleted)}
      aria-pressed={hideCompleted}
      aria-label={hideCompleted ? 'Show completed workouts' : 'Hide completed workouts'}
      className="d-flex w-full items-center justify-between bg-transparent border-0 px-0 py-1"
    >
      <span className={`font-roboto-condensed font-semibold text-sm leading-5 ${hideCompleted ? 'text-primary' : 'text-ivory'}`}>
        Completed Workouts
      </span>
      {hideCompleted ? <EyeOff size={20} className="text-primary" /> : <Eye size={20} className="text-ivory" />}
    </button>
  )
}
